var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collapse-transition',[_c('div',{staticClass:"alert alert-info mobile-warning text-center d-block d-sm-none",attrs:{"role":"alert"}},[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":['fal', 'mobile-android']}}),_vm._v(" "+_vm._s(_vm.$t('mobileDetected'))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }